/* DON'T EDIT THIS FILE: edit original and run build again */ import firebase from "firebase/compat/app";

export const getLoggedFirebaseUser = () => {
  // @ts-expect-error bad types
  return firebase.auth().currentUser;
};
